import React, {useEffect, useRef, useState} from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import '../../../assets/styles/Footer/footerAbout.css'
import { Helmet } from "react-helmet";
import FooterNav from "./FooterNav";
import { useSelector } from 'react-redux';
import FootNav from '../../User_Profile/Footer/Footer-nav/FootNav';
import { Trans, useTranslation } from 'react-i18next';

const About = () => {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const { state } = useLocation();
  console.log(state, "state")
  const userData = useSelector((state) => state?.auth?.user?.user);
  // const [Loading, setLoading] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);
  const [isIntersecting, setIntersecting] = useState(false);
  const buttonRef1 = useRef(null);
  const buttonRef2 = useRef(null);

  useEffect(() => {
    setIsFlipped(true);
    const timer = setTimeout(() => {
      setIsFlipped(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIntersecting(entry.isIntersecting)
      const timer = setTimeout(() => {
        setIntersecting(false);
      }, 1000);
      return () => clearTimeout(timer)
    }
  );

    observer.observe(buttonRef1.current);
    return () => {
      observer.disconnect();
    };
  }, [buttonRef1]);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIntersecting(entry.isIntersecting)
      const timer = setTimeout(() => {
        setIntersecting(false);
      }, 1000);
      return () => clearTimeout(timer)
    }
    );

    observer.observe(buttonRef2.current);
    return () => {
      observer.disconnect();
    };
  }, [buttonRef2]);

  useEffect(() =>{
    // if (userData && userData?.type === false) {
    //   if (userData?.activation_status === 0) {
    //     navigate("/firstStep");
    //   } else if ( userData?.activation_status === 1) {
    //     navigate("/secondStep");
    //   } else if ( userData?.activation_status === 2) {
    //     navigate("/thirdStep");
    //   } else {
    //     navigate("/", { 
    //       state: { 
    //         item: [
    //           userData.location.coordinates[0].coords.lng,
    //           userData.location.coordinates[0].coords.lat,
    //         ],
    //       },
    //     });
    //   }
    // }
    // setTimeout(() => {
    //   setLoading(false)
    // }, 3000)
    if(userData && state !== "FooterMain"){
      (!userData.type && userData?.activation_status === 3) || (userData?.type && userData?.subscription) ?
          navigate("/", { 
            state: { 
              item: [
                userData.location.coordinates[0].coords.lng,
                userData.location.coordinates[0].coords.lat,
              ],
            },
          })
      :
      navigate('/login')
    }
  },[])
  return (
    <>
      <Helmet>
        <meta property="og:url" content="/about" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="About" />
        <meta property="og:description" content="iBouge, a geo-network. We use maps to connect the global community" />
      </Helmet>
    <div id="wrapper" className='bg-light'>
    <div className="pre-content"></div>
    <div className="about-content w-100">
      <FooterNav statusL = {userData? "LoggedIn" : ""} from = {"About"}/>
      {/* <div className="d-flex justify-content-end">
        <header className='aboutheader'>
          <img src="/Images/logo.png" alt="Ibouge Logo" style={{cursor:"pointer"}} onClick={() => navigate("/about")}  />
          <span style={{color: "#9f47a0", position: "relative", top: "-2px", fontSize: "1.1rem"}}>&#174;</span>
        </header>
        <button
          className="signup_button text-white ms-auto border-0 shadow-none"
          style={{position:"relative", top: 40}}
          onClick={() => {
            navigate("/signup");
          }}
        >
          Sign Up
        </button>
      </div> */}
      <main className='aboutmain mx-auto'>
        <section className='aboutsection' id="what">
          <div className="about-what-left">
            <div className="about-what-left-bg" style={{zIndex:-10}}></div>
            <div className='h-100 px-4 pt-4 pb-3'>
            {'Loading' === true ?
              <div style={{ display: "flex", justifyContent: "center", alignItems:"center", height: "100px", margin: "5%" }}>
                <div className="loading">
                </div>
              </div>
              :
                // <iframe
                //   width="100%"
                //   height="100%"
                //   margin="10px"
                //   do-not-allow="autoplay"
                //   src={"video/ibouge.mp4"}
                //   allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                //   allowFullScreen
                //   playsInline
                //   title="Embedded youtube"
                // />
                <video width="100%" height="100%" controls>
                  <source src="video/ibouge.mp4" type="video/mp4"/>
                </video>
            }
            </div>
          </div>
          <div className="what-right topper">
            <div className='d-flex mt-5 flex-row pt-2 px-0 px-sm-2' >
              <div className='text-start'>
                <span>{t('introducing')}</span>
                <h1 className='about-h1' >
                  <Trans
                    i18nKey="whatIsIBouge"
                    components={[
                      <small style={{fontSize:"14px", marginRight:"2px", position:"relative", top: "-10px"}} />
                    ]}
                  />
                </h1>
              </div>
              <button
                className={`signup_button_about text-white mt-3 ms-auto border-0 shadow-none ${isFlipped ? "flip" : ""}`}
                onClick={() => {
                  navigate("/signup");
                }}
              >
                {t('sign_up')}
              </button>
            </div>
            <div className='d-flex flex-column align-items-md-start align-items-center px-2 pe-md-5 ps-md-0'>  
              <p>{t('ibougeIntro')}</p>
              <p>{t('products_intro')}</p>
              <ul>
                <li><strong>1</strong> {t('product1')}</li>
                <li><strong>2</strong> {t('product2')}</li>
                <li><strong>3</strong> {t('product3')}</li>
                <li><strong>4</strong> {t('product4')}</li>
              </ul>
            </div>
          </div>
        </section>

        <section className='aboutsection' id="diff">
          <div className="diff-content topper">
            <h1 className="about-h1" style={{maxWidth: 240}}>
              <Trans
                i18nKey="whatDifferentiates"
                components={[
                  <span className="highlight-text"/>
                ]}
              />
            </h1>

            <p style={{maxWidth: 270}}>{t('ibougeDescription')}</p>

            <img src="/Images/world.png" alt="" />
          </div>
        </section>

        <section className='aboutsection' id="who">
          <div className="who-image">
            <img src="/Images/cards.png" alt="" />
          </div>
          <div className="who-content">
            <h1 className='about-h1'>{t('whoShouldSignUp')}<br/>
            <span>{t('twoTypesAccounts')}</span></h1>

            <img src="/Images/cards.png" alt="" />

            <p style={{color:"black"}} className='me-3'>{t('accountTypes')}</p>
          </div>
          <div className="who-content">
            <ul>
              <li>{t('businessAccountDescription')}</li>
              <li>{t('businessPageFeatures')}</li>
              <li style={{fontSize: 18, fontWeight: 1000, lineHeight: 1}}>{t('business_price')}</li>
            </ul>
          </div>
        </section>

        <section className='aboutsection' id="sign-up">
          <div className="sign-up-content">
            <div className="suc-title">
              <h1 className='about-h1 pe-4'>
                <Trans
                  i18nKey="howDoISignUp"
                  components={[
                    <span className="highlight-text" />,
                    <br />
                  ]}
                />
              </h1>
              <p>{t('signUpInstructions')}</p>
              <div className='suc-button'>
                <button
                  className={`signup_button_about text-white mt-3 border-0 shadow-none ${isIntersecting ? "signup-flip" : ""}`}
                  ref={buttonRef1}
                  onClick={() => {
                    navigate("/signup");
                  }}
                >
                  {t('sign_up')}
                </button>
              </div>
            </div>
            <div className="sup-process">
              <div className="step step1">
                <img src="/Images/app1.png" alt="" />
                <div className="desc">
                  <span className='px-1 px-sm-3 py-0 py-sm-1 py-md-2'>{t('step1')}</span>
                  <p>{t('step1_desc')}</p>
                </div>
              </div>
              <div className="step step2">
                <img src="/Images/app2.png" alt="" />
                <div className="desc">
                  <span className='px-1 px-sm-3 py-0 py-sm-1 py-md-2'>{t('step2')}</span>
                  <p>{t('step2_desc')}</p>
                </div>
              </div>
              <div className="step step3">
                <img src="/Images/app3.png" alt="" />
                <div className="desc">
                  <span className='px-1 px-sm-3 py-0 py-sm-1 py-md-2'>{t('step3')}</span>
                  <p>{t('step3_desc')}</p>
                </div>
              </div>
              <div className="step step4">
                <img src="/Images/app4.png" alt="" />
                <div className="desc">
                  <span className='px-1 px-sm-3 py-0 py-sm-1 py-md-2'>{t('step4')}</span>
                  <p>{t('step4_desc')}</p>
                </div>
              </div>
              <div className="step step5">
                <img src="/Images/app5.png" alt="" />
                <div className="desc done">
                  <span className='px-1 px-sm-3 py-0 py-sm-1 py-md-2'>{t('done')}</span>
                  <p>{t('done_steps')}</p>
                </div>
              </div>

              <div className="form">
                <h2 className='mb-n1'>{t('signup_cta')}</h2>
                <p className='pt-n1'>{t('enjoyBenefits')}</p>
                <button
                  className={`${isIntersecting ? "signup-flip" : ""}`}
                  ref={buttonRef2}
                  onClick={() => navigate('/signup',{
                    state:"business"
                  }
                )}>{t('sign_up')}</button>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  </div>
  <footer>
    <p>iBouge ® • {t('copyright')} © 2026 iBouge Inc. • {('allRightsReserved')}.</p>
    <p>{t('patentNumbers')}: US D921,652; US D921,653; US D921,032; US D921,006; US D921,005; US D921,004.</p>
  </footer>
  <FootNav from={"About"} />
  </>
  )
}

export default About